import { connect } from "react-redux";
import CalculsParameters from "../components/CalculsParameters";
import "../components/Calculs.scss";
import { updateCalculsColumns } from "../../user/actions";

export default connect(
  (state) => ({
    calculsColumns: state.user.informations.calculsColumns || [],
  }),
  (dispatch) => ({
    updateCalculsColumns: (columns) => {
      dispatch(updateCalculsColumns(columns));
    },
  }),
)(CalculsParameters);
